const ResultDashboard = ({
  patientDetails,
  setCurrentPage,
  setEmiratesId,
  translationMap
}) => {

  return (
    <>
      <section
        className="w-100 clearfix ManageDependentMainSection"
        id="CoverPlanActive">
        
        <div className="container customContainer">
          <div className="Title_Inner_Box">
            <h6 className="MainTitleOne">{translationMap?.viewMrn}</h6>
          </div>
          <div className="cover_inner_wrapper cover_inner_wrapper2">
            <div className="cover_main_box1">
              <div className="medical_fitness_white_box">
                <div className="medical_white_process_box">
                  <div className="title_txt">
                    <h6 className="Gray_Title" style={{ direction: "ltr" }}>
                      {translationMap?.mrnField}{" "}
                      {patientDetails?.patientMRN}
                    </h6>
                    <ul className="ul_box">
                      <li>
                        <p>
                          <b>{translationMap?.emiratesId}: </b>{" "}
                          <p>{patientDetails.patientAEID}</p>
                        </p>
                      </li>
                      <li>
                        <p>
                          <b>{translationMap?.name}: </b>{" "}
                          <p>
                            {patientDetails?.PatientFirstName ?
                            patientDetails.PatientFirstName.charAt(0).toUpperCase() +
                            patientDetails.PatientFirstName.slice(1).toLowerCase() +
                            " " :
                            ""}
                            {patientDetails?.patientMiddleName ?
                            patientDetails.patientMiddleName.charAt(0).toUpperCase() +
                            patientDetails.patientMiddleName.slice(1).toLowerCase() +
                            " " :
                            ""}
                            {patientDetails?.patientLastName ?
                            patientDetails.patientLastName.charAt(0).toUpperCase() +
                            patientDetails.patientLastName.slice(1).toLowerCase() :
                            ""}
                          </p>
                        </p>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="medical_white_proces_btn_box">
                  <span>
                    {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                    <a
                      className="bluetrans_btn_link"
                      onClick={() => {
                        setCurrentPage("home");
                        setEmiratesId("");
                      }}>
                      
                      {translationMap?.back}
                    </a>
                  </span>
                </div>
              </div>
            </div>
            <div className="cover_main_box2"></div>
          </div>
        </div>
      </section>
    </>);

};

export default ResultDashboard;